import { Button } from "./ui/button";
import { motion } from "framer-motion";
import { QuoteModal } from "./QuoteModal";


const Process = () => {
  const steps = [
    {
      number: "01",
      title: "Kontakt aufnehmen",
      description: "Beginne damit, das Formular „Kostenloses Angebot anfordern“ auf unserer Website auszufüllen, um uns deinen Umzugsservice Bedarf mitzuteilen, damit wir uns um deine Anliegen kümmern können."
    },
    {
      number: "02",
      title: "Termin für deinen Kostenvoranschlag",
      description: "Als Nächstes vereinbaren wir einen Besichtigungstermin, bei dem wir dir einen Kostenvoranschlag für deine Umzugsservice Bedürfnisse erstellen."
    },
    {
      number: "03",
      title: "Wir erledigen den Auftrag",
      description: "Nachdem du unserem Kostenvoranschlag zugestimmt hast, vereinbaren wir einen Termin für die Ausführung der Arbeit. Unser Team wird sich bemühen, deine Erwartungen zu übertreffen!"
    }
  ];

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center max-w-3xl mx-auto"
        >
          <span className="font-semibold text-primary uppercase tracking-wider text-sm">Der Prozess</span>
          <h2 className="font-heading text-3xl md:text-5xl mt-2">Unser einfacher 3-Schritt-Prozess</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {/* Connector Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-neutral-200 -z-10"></div>
          
          {steps.map((step, index) => (
            <motion.div 
              key={index} 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="flex flex-col items-center text-center bg-white"
            >
              <div className="w-24 h-24 bg-neutral-100 rounded-full flex items-center justify-center text-primary font-heading text-3xl mb-6 shadow-sm border-4 border-white relative z-10 transition-transform hover:scale-110 duration-300">
                {step.number}
              </div>
              <h3 className="font-heading text-2xl mb-4">{step.title}</h3>
              <p className="text-neutral-600 font-medium mb-8">
                {step.description}
              </p>
              <div className="flex flex-col gap-3 w-full mt-auto">
                <QuoteModal>
                  <Button className="w-full">
                    Kostenloses Angebot anfordern &rarr;
                  </Button>
                </QuoteModal>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;